import React, { Component } from 'react';
import reactLogo from './img/react-logo.svg';
import wordpressLogo from './img/wordpress-logo.svg';
import PHPLogo from './img/php-logo.svg';
import SASSLogo from './img/sass-logo.svg';
import resume from './files/Will_Christenson_Resume_2018_C.pdf';
import profilePhoto from './img/will-skidmore-bluffs.jpg';
// import Image from './Image';
import BackgroundImage from './BackgroundImage';
import { NavLink } from 'react-router-dom';
// import { Link } from 'react-router-dom';

export class About extends Component {
	render() {
		return (
			<div className="content-container about-container">
				<h1 className="punch-headline"><a href="mailto:will@dangercode.net" target="_blank" rel="noopener noreferrer">Will Christenson</a></h1>

				<div className="about-description-container">
					<BackgroundImage className="about-profile-photo" src={profilePhoto} />
					<div className="about-description">
						<p className="paragraph-lead">
							I am a freelance full-stack web developer based in Portland, Oregon. With over five years in the industry working for small to medium businesses,
							my focus has been primarily on building custom themes & plugins from scratch for WordPress websites.<br/><br/>
							<NavLink to="/portfolio">Check out examples of recent work</NavLink>
						</p>
					</div>
				</div>
				<h4 className="tagline">Some of my proficiencies include:</h4>

				<ProficienciesList />

				<div className="proficiencies-addendum">
					<a href="https://www.ecma-international.org/ecma-262/6.0/" target="_blank" rel="noopener noreferrer">ES6</a>
					<a href="https://babeljs.io/" target="_blank" rel="noopener noreferrer">Babel</a>
					<a href="https://gulpjs.com/" target="_blank" rel="noopener noreferrer">Gulp</a>
					<a href="https://webpack.js.org/" target="_blank" rel="noopener noreferrer">Webpack</a>
					<a href="https://github.com/MrSpecific/" target="_blank" rel="noopener noreferrer">Git</a>
					<a href="https://foundation.zurb.com/sites.html" target="_blank" rel="noopener noreferrer">Foundation</a>
					<a href="https://getbootstrap.com/" target="_blank" rel="noopener noreferrer">Bootstrap</a>
				</div>

				<h2>
					If you prefer, take a look at <a href={resume} target="_blank" rel="noopener noreferrer">my résumé</a> or
					<NavLink to="/contact"> contact me</NavLink>
				</h2>
			</div>
		)
	}
};

const ProficienciesList = (props) => {
	return (
		<ul className="proficiencies-list">
			<ProficiencyLi>
				<a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">
					<span className="proficiency-name">React.js</span>
					<img className="proficiency-logo react-logo" src={reactLogo} alt="React.js"/>
				</a>
			</ ProficiencyLi>
			<ProficiencyLi>
			<a href="https://sass-lang.com/" target="_blank" rel="noopener noreferrer">
			<span className="proficiency-name">SASS</span>
			<img className="proficiency-logo" src={SASSLogo} alt="SASS"/>
			</a>
			</ ProficiencyLi>
			<ProficiencyLi>
				<a href="https://wordpress.org/" target="_blank" rel="noopener noreferrer">
					<span className="proficiency-name">WordPress</span>
					<img className="proficiency-logo wordpress-logo" src={wordpressLogo} alt="WordPress"/>
				</a>
			</ ProficiencyLi>
			<ProficiencyLi>
				<a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">
					<span className="proficiency-name">PHP</span>
					<img className="proficiency-logo" src={PHPLogo} alt="PHP"/>
				</a>
			</ ProficiencyLi>
		</ul>
	);
}

const ProficiencyLi = (props) => {
	return <li className="proficiency-item">{props.children}</li>
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js